import { render, staticRenderFns, recyclableRender, components } from "./address.vue?vue&type=template&id=db675620&scoped=true&"
var renderjs
import script from "./address.vue?vue&type=script&lang=js&"
export * from "./address.vue?vue&type=script&lang=js&"
import style0 from "./address.vue?vue&type=style&index=0&lang=css&"
import style1 from "./address.vue?vue&type=style&index=1&id=db675620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db675620",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/address/address.vue"
export default component.exports